'use strict';

import $ from 'jquery';

$(function () {
    $('body').on('click' ,'a', function (){

        if( typeof $(this).data('event') !== 'undefined'  )
        {
            window.dataLayer.push($(this).data());
        }
    });
});
